import { useState } from 'react';
import { ArrowBackIosNewRounded } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { InlineEditInput } from '@/components/shared/inline-edit-input';
import { ActionsMenu } from '@/components/shared/page-header/actions-menu';
import { useNotification } from '@/context/notification';
import { useDelete } from '@/data/learning-path/path-management';
import { DeleteItemDialog } from '@/packages/learning-path/pages/path-management/components/delete-item-dialog';
import { ImageUpload } from '@/packages/learning-path/pages/path-management/pages/edit-path/components/image-upload';
import { useManagePath } from '@/packages/learning-path/pages/path-management/pages/edit-path/context';

export const EditPathHeader = () => {
  const navigate = useNavigate();
  const { title, setTitle, description, setDescription, pathId } =
    useManagePath();
  const { mutate: deletePath, isPending } = useDelete();
  const [deletePathDialogOpen, setDeletePathDialogOpen] = useState(false);
  const { toast } = useNotification();

  const handleDelete = () => {
    if (!pathId) return;
    deletePath(pathId, {
      onSuccess: () => {
        navigate('/empresa/gestao-de-trilhas');
        toast({
          title: 'Trilha excluída com sucesso',
          content: 'A trilha foi excluída com sucesso.',
          type: 'success',
        });
      },
      onError: () => {
        toast({
          title: 'Erro ao excluir trilha',
          content: 'Ocorreu um erro ao tentar excluir a trilha.',
          type: 'error',
        });
      },
    });
  };

  const handleTitle = async (value: string) => {
    setTitle(value);
    return true;
  };

  const handleDescription = async (value: string) => {
    setDescription(value);
    return true;
  };

  const actions = [
    {
      label: 'Excluir trilha',
      onClick: () => setDeletePathDialogOpen(true),
    },
  ];

  return (
    <Stack direction="row" justifyContent="space-between" my={2}>
      <Stack flex={1}>
        <Box width="fit-content">
          <Button
            startIcon={<ArrowBackIosNewRounded fontSize="small" />}
            onClick={() => navigate('/empresa/gestao-de-trilhas')}
          >
            Gestão de trilhas
          </Button>
        </Box>
        <Typography
          component={InlineEditInput}
          variant="h1"
          fontWeight="semibold"
          color="primary.dark"
          onAccept={handleTitle}
          value={title}
          mb={2}
        />
        <ImageUpload />
        <Box mt={2}>
          <Typography variant="body2" fontWeight="bold">
            Descrição
          </Typography>
          <Typography
            component={InlineEditInput}
            value={description}
            onAccept={handleDescription}
          />
        </Box>
      </Stack>
      <ActionsMenu actions={actions} />
      {deletePathDialogOpen && (
        <DeleteItemDialog
          onClose={() => setDeletePathDialogOpen(false)}
          onSubmit={handleDelete}
          loading={isPending}
        />
      )}
    </Stack>
  );
};
